import {
  MedicalSystemCatalogDto,
  MedicalSystemRtSystemDto,
  ParameterCombinationDto,
  QaEquipmentCatalogDto,
  QaEquipmentRtSystemDto,
  RunReferenceMeasurementRequestDto,
  RunReferenceMeasurementRequestDtoTypeEnum,
  RunReferenceMeasurementRequestInJobOccurrenceDto,
  RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum,
  WorkItemDto,
} from '@/api/generator';
import { Measurement } from '../types';
import { useToggle } from '@vueuse/core';
import { ref } from 'vue';
import { useJobOccurrence } from '@/views/jobOccurrences/utils/useJobOccurrence';

export function useReferenceMeasurement() {
  const [isReferenceMeasurementDialogOpen, toggleReferenceMeasurementDialog] = useToggle(false);

  const { jobOccurrence } = useJobOccurrence();

  const referenceMeasurement = ref<Measurement | undefined>(undefined);

  function getReferenceMeasurement(
    combination: ParameterCombinationDto,
    medicalSystem: MedicalSystemRtSystemDto | MedicalSystemCatalogDto,
    qaEquipmentSystemEntities: QaEquipmentRtSystemDto[] | QaEquipmentCatalogDto[],
    workitem?: WorkItemDto,
  ): Measurement {
    const request = workitem?.id
      ? ({
          parameterCombinationHash: combination.hash,
          jobOccurrenceId: jobOccurrence.value.id,
          workItemId: workitem.id,
          $type:
            RunReferenceMeasurementRequestInJobOccurrenceDtoTypeEnum.PtwPtw100BeamConstancyCheckApplicationMeasurementRunReferenceMeasurementRequestInJobOccurrenceDtoPtwPtw100BeamConstancyCheckApplication,
        } satisfies RunReferenceMeasurementRequestInJobOccurrenceDto)
      : ({
          combination,
          parameterCombinationHash: combination.hash,
          $type:
            RunReferenceMeasurementRequestDtoTypeEnum.PtwPtw100BeamConstancyCheckApplicationMeasurementRunReferenceMeasurementRequestDtoPtwPtw100BeamConstancyCheckApplication,
        } satisfies RunReferenceMeasurementRequestDto);

    return {
      targetSystem: medicalSystem,
      supportSystems: qaEquipmentSystemEntities,
      setup: {
        targetSystem: combination.targetSystemValues || undefined,
        supportSystem: combination.supportSystemValues || undefined,
      },
      request,
      measurementId: combination.referenceMeasurementInfo?.measurementId,
    } satisfies Measurement;
  }

  function openReferenceMeasurement(
    combination?: ParameterCombinationDto,
    medicalSystem?: MedicalSystemRtSystemDto | MedicalSystemCatalogDto,
    qaEquipmentSystemEntities?: QaEquipmentRtSystemDto[] | QaEquipmentCatalogDto[],
    workitem?: WorkItemDto,
  ) {
    if (combination && medicalSystem && qaEquipmentSystemEntities) {
      referenceMeasurement.value = getReferenceMeasurement(
        combination,
        medicalSystem,
        qaEquipmentSystemEntities,
        workitem,
      );
      toggleReferenceMeasurementDialog(true);
    }
  }

  return {
    openReferenceMeasurement,
    referenceMeasurement,
    toggleReferenceMeasurementDialog,
    isReferenceMeasurementDialogOpen,
  };
}
